/** One level of the detail drill. `rootLabel` is the Back label shown at depth 1 (the screen drilled from). */
export type DetailFrame =
  | { kind: 'issue'; id: string; siteId?: string | null; rootLabel: string }
  | { kind: 'site'; siteId: string; rootLabel: string }
  | { kind: 'hod'; department: string; hodName?: string | null; hodPhone?: string | null; hodEmail?: string | null; rootLabel: string }

export type DetailStack = DetailFrame[]

/** What an "open HOD workload" action carries — the department + the HOD contact already in hand. */
export interface HodOpenRef {
  department: string
  name?: string | null
  phone?: string | null
  email?: string | null
}

export type DetailStackAction =
  | { type: 'push'; frame: DetailFrame }
  | { type: 'pop' }
  | { type: 'clear' }

/** Pure stack transitions. Push appends; pop drops the top; clear empties. */
export function detailStackReducer(stack: DetailStack, action: DetailStackAction): DetailStack {
  switch (action.type) {
    case 'push':
      return [...stack, action.frame]
    case 'pop':
      return stack.slice(0, -1)
    case 'clear':
      return []
  }
}

/** Back-button label: the root label at depth 1, "Back" deeper, "" when empty. */
export function backLabel(stack: DetailStack): string {
  if (stack.length === 0) {
    return ''
  }
  const top = stack[0]
  if (stack.length === 1 && top !== undefined) {
    return top.rootLabel
  }
  return 'Back'
}
